import { IAdminMembership } from '../../../../../store/admin/memberships/store';

export const getMemberSelection = (member: IAdminMembership, selectedMembers: IAdminMembership[]) =>
  Boolean(selectedMembers.find((item: IAdminMembership) => item.id === member.id))
    ? selectedMembers.filter((item: IAdminMembership) => item.id !== member.id)
    : [...selectedMembers, member];
